/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'

import SalesPediaMain from '../../modules/salesPediaMain/SalesPediaMain'



const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className="card mb-5 mb-xl-10">
      <SalesPediaMain></SalesPediaMain>
    </div>
    {/* end::Row */}
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{"Ana Sayfa"}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
